import styled from 'styled-components';
import { TextCenter } from 'style/styleComponent/styled';

export const TextAlignCenter = styled(TextCenter)`
  color: var(--SECONDARY-default);
`;
